import { jsx as a } from "react/jsx-runtime";
import i from "react";
import { cva as o } from "../../../../../node_modules/class-variance-authority/dist/index.js";
import { cn as m } from "../../utils/cn.js";
import n from "../../../node_modules/lucide-react/dist/esm/icons/loader-circle.js";
const f = o("gst-animate-spin gst-stroke-current", {
  variants: {
    size: {
      default: "gst-size-4",
      sm: "gst-size-2",
      md: "gst-size-4",
      lg: "gst-size-6",
      xl: "gst-size-8"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), p = i.forwardRef(
  ({ size: s, className: t, ...e }, r) => /* @__PURE__ */ a(
    n,
    {
      ref: r,
      className: m(f({ size: s }), t),
      ...e
    }
  )
);
p.displayName = "Spinner";
export {
  p as default
};
